import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { config } from '@/config';
import { useAuth } from './AuthContext';

const ThemeContext = createContext();

const BACKEND_URL = config.BACKEND_URL;
const API = BACKEND_URL;

export const ThemeProvider = ({ children }) => {
  const { user } = useAuth();
  const [theme, setTheme] = useState(() => {
    // Priority: user preference > localStorage > system preference
    if (user?.theme) return user.theme;
    const saved = localStorage.getItem('theme');
    if (saved) return saved;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    if (user?.theme && user.theme !== theme) {
      setTheme(user.theme);
    }
  }, [user]);

  const toggleTheme = async () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);

    // Save to backend if user is logged in
    if (user) {
      try {
        const token = sessionStorage.getItem('token');
        await axios.put(
          `${API}/users/${user.id}`,
          { theme: newTheme },
          { params: { token } }
        );
      } catch (error) {
        console.error('Failed to save theme preference:', error);
      }
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
